<div class="ota-details pb-3 v3" *tuiLet="selectdatesAndAccupancy$|async as datesAndAccupancy">
    <h2 class="title">
        {{'comparateur'|translate}}
    </h2>
    <div>
        <nav>
            @for (engine of selectHotelBookingData$|async; track $index) {
                @if (engine[1].bestPrices.googleHotelAds) {
                    <ng-container 
                        [ngTemplateOutlet]="nav" 
                        [ngTemplateOutletContext]="{$implicit: engine[1].bestPrices.googleHotelAds, engine: engine[0]+'.googleHotelAds', datesAndAccupancy, price: engine[1].bestPrices.googleHotelAds.detailPrice.Ttc}"
                    >
                    </ng-container>
                }
                @if (engine[1].bestPrices.bestprice && engine[0]=='b') {
                    <ng-container 
                        [ngTemplateOutlet]="nav" 
                        [ngTemplateOutletContext]="{$implicit: engine[1].bestPrices.bestprice, engine: engine[0]+'.bestprice', datesAndAccupancy, price: engine[1].bestPrices.bestprice.detailPrice_without_promo.Ttc}"
                    >
                    </ng-container>
                }
                @if (engine[1].bestPrices.bestprice && ['b'].includes(engine[0]) == false) {
                    <ng-container 
                        [ngTemplateOutlet]="nav" 
                        [ngTemplateOutletContext]="{$implicit: engine[1].bestPrices.bestprice, engine: engine[0]+'.bestprice', datesAndAccupancy, price: engine[1].bestPrices.bestprice.detailPrice_without_promo.Ttc}"
                    >
                    </ng-container>
                }
                @if (engine[1].bestPrices.partner) {
                    <ng-container 
                        [ngTemplateOutlet]="nav" 
                        [ngTemplateOutletContext]="{$implicit: engine[1].bestPrices.partner, engine: engine[0]+'.partner', datesAndAccupancy, price: engine[1].bestPrices.partner.detailPrice_without_promo.Ttc}"
                    >
                    </ng-container>
                }
            }
        </nav>
        <div class="detailed-ota" [@fadingTransition]="selectedOTATemplate">
            <ng-container [ngTemplateOutlet]="selectedOTATemplate">
            </ng-container>
        </div>
    </div>
    <div class="d-flex">
        <a [routerLink]="['..']" class="btnClose mt-3" queryParamsHandling="merge">
            {{'retour'|translate}}
        </a>
    </div>
</div>

<ng-template #nav let-data let-engine="engine" let-price="price" let-datesAndAccupancy="datesAndAccupancy">
    <div #navItem (click)="selectedOTATemplate = details" [class.active]="selectedOTATemplate == details">
        <div class="ota-tab">
            @switch (true) {
                @case (engine.includes('googleHotelAds')) {
                    <img src="assets/engines/asseenongoogle.svg" />
                }
                @case (engine == 'b.bestprice') {
                    <img src="assets/engines/booking.svg" />
                }
                @case (engine == 'a.bestprice') {
                    <img src="assets/engines/agoda.svg" />
                }
                @case (engine == 'bc.bestprice') {
                    <img src="assets/engines/fidelity.svg" />
                }
                @case (engine == 'bc.partner') {
                    <img src="assets/engines/connected-partner.svg" />
                }
                @case (engine == 'b.partner') {
                    <img src="assets/engines/partner.svg" />
                }
                @default {
                    <span><b>{{TRANSLATIONS[engine]|| engine|translate}}</b></span>
                }
            }
            <tui-icon icon="@tui.chevron-right" [style.width]="'24px'"></tui-icon>
        </div>
        <ng-template #details>
            @let _price = price|currencyExchange:data.currency:$any(datesAndAccupancy?.currency) |async;
            @let _etab_price = price|currencyExchange:data.currency:data.currency |async;
            <div class="card">
                <div class="card-header">
                    <span class="total">
                        <span class="price">{{ _price }}</span>
                    </span>
                    <app-occupancy-info [bestPrice]="data" [datesAndAccupancy]="datesAndAccupancy"></app-occupancy-info>
                </div>
                <div class="card-body">
                    <label *tuiLet="getRoomName(data.code_room)|async as roomName">{{roomName}}</label> 
                    <div class="card-body-details">
                        <img [src]="getImage(data.code_room)|async" alt="">
                        <div>
                            <ul class="info list-unstyled">
                                @for (item of data.addedvalues; track $index) {
                                    @if(item.idbo){
                                        <li>{{item.idbo+'-titer' | removeWhitespace | customTranslate:item.values }}</li>
                                    }
                                    @else {
                                        <li>{{item.name | removeWhitespace | customTranslate:item.values }}</li>
                                    }
                                }
                            </ul>
                            
                        </div>
                    </div>
                    <ul class="condition list-unstyled">
                        <li *tuiLet="bookingPolicy.getAnnulation(data.conditiondetail.annulation, datesAndAccupancy.range.from) as annulations">
                            <span tuiHintDirection="bottom-right" [tuiHint]="tooltip" [tuiHintAppearance]="'dark'" class="text-decoration-underline">
                                <tui-icon icon="@tui.info" style="width: 14px;"></tui-icon>
                                {{annulations[0].traduction.codemot|customTranslate:annulations[0].traduction.params}}
                            </span>
                            <ng-template #tooltip>
                                <h6>{{'conditionsdannulation'|translate}}:</h6>
                                <ul class="condition-hint list-unstyled">
                                    @if ( [BookingPolicyService._NoRemborsable, BookingPolicyService._NoRemborsableNoDetected].includes(data.conditiondetail.annulation.type) ) {
                                        <li>
                                            <span [innerHTML]="'attention!encasdannulationoudemodification,letablissementprelevelemontanttotaldelareservation'|translate"></span>
                                        </li>
                                    }
                                    @else {
                                        @for (annulation of annulations; track $index) {
                                            <li>
                                                {{annulation.traduction.codemot|customTranslate:annulation.traduction.params}}
                                                @if (annulation.exeption) {
                                                    <small>
                                                        {{annulation.exeption.codemot|customTranslate:annulation.exeption.params}}
                                                    </small>
                                                }
                                            </li>
                                        }
                                        @if(data.conditiondetail.prepaye.checked){
                                            <li *ngIf="bookingPolicy.getPrePaiement(data.conditiondetail.prepaye) as prepay">
                                                {{prepay.codemot|customTranslate:prepay.params}}
                                            </li>
                                        }
                                        @if(data.conditiondetail.show.checked){
                                            <li *ngIf="bookingPolicy.getNoShow(data.conditiondetail.show) as show">
                                                <b>{{'noshow'|translate}}: &nbsp;</b>
                                                {{show.codemot|customTranslate:show.params}}
                                            </li>
                                        }
                                    }
                                </ul>
                            </ng-template>
                        </li>
                        <!-- @for (item of data.roomtype_ota?.items; track $index) {
                            <li>{{item.item_name | customTranslate: item.values }}</li>
                        } -->
                    </ul>
                </div>
                <div class="card-footer">
                    @if (engine != 'so.bestprice' && engine != 'so.googleHotelAds') {
                        <button 
                            [routerLink]="['../../..', 'snapshot']" 
                            [queryParams]="{link: getLink(data, datesAndAccupancy), price: _price+' ≈ '+_etab_price}" 
                            routerLinkActive="active" 
                            queryParamsHandling="merge"
                        >
                            {{'voirlacapture'|translate}}
                        </button>
                    }
                </div> 
            </div>
        </ng-template>
    </div>
</ng-template>